import { render, staticRenderFns } from "./reset-password.vue?vue&type=template&id=21c150ce&scoped=true"
import script from "./reset-password.vue?vue&type=script&lang=js"
export * from "./reset-password.vue?vue&type=script&lang=js"
import style0 from "./reset-password.vue?vue&type=style&index=0&id=21c150ce&prod&lang=scss&scoped=true"
import style1 from "./reset-password.vue?vue&type=style&index=1&id=21c150ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c150ce",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/account/model/reset-password.vue
// module id = null
// module chunks = 